// Wires the controls together: the powertrain driver, the header and dock
// controls, the keyboard shortcuts and the output level from the view state.

import type { ViewStore } from "../../state/store";
import type { AudioSession } from "./audio-session";
import { mountDock } from "./dock";
import { mountHeaderControls } from "./header";
import { bindKeyboard } from "./keyboard";
import { PowertrainDriver } from "./powertrain-driver";

export interface ControlsMount {
  store: ViewStore;
  audio: AudioSession;
  /** Where the header controls go. */
  header: HTMLElement;
  /** The dock element. */
  dock: HTMLElement;
}

export interface Controls {
  driver: PowertrainDriver;
  unmount(): void;
}

export function mountControls({ store, audio, header, dock }: ControlsMount): Controls {
  const driver = new PowertrainDriver(store, audio);
  const ensureAudio = (): void => {
    if (audio.status === "off" || audio.status === "failed") void audio.start();
  };
  const toggleAudio = (): void => {
    if (audio.status === "on") void audio.stop();
    else ensureAudio();
  };

  const level = (): void => audio.setLevel(store.state.audio.muted ? 0 : store.state.audio.volume);
  level();

  const offs = [
    mountHeaderControls(header, { store, audio, toggleAudio }),
    mountDock(dock, { store, audio, driver, ensureAudio }),
    bindKeyboard({ store, audio, driver, toggleAudio, ensureAudio }),
    store.subscribe(level),
    audio.onStatus(level),
  ];
  return {
    driver,
    unmount() {
      for (const off of offs) off();
      driver.dispose();
    },
  };
}
